module.exports = __webpack_public_path__ + "img/signature_sample.2aeb1bf1.png";